import type { MatchResultDetails, MatchResultRequestData, MatchResultSportsFromBackend } from './types';

import { URL } from '../../../constants';
import { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

// ---

// TODO: сюда может прийти пустой объект, нужно обработать его как ошибку
// TODO: https://jira.tennisi.it/browse/WEB-1706
// Доделать после задачи https://jira.tennisi.it/browse/WEB-1588
// Потому что придется расширять defaultRequestService и будет куча конфликтов с задачей 1588

export const getMatchResultDetails = (
  config: ServiceConfig,
  matchId: number,
) => {
  type AdapterProps = { response: MatchResultDetails };
  const url = `${URL.MATCH_RESULT_DETAILS}/${matchId}`;

  return defaultRequestService<AdapterProps>(url, config.instance.get);
};

export const getMatchResultSports = (config: ServiceConfig) => {
  type AdapterProps = { response: MatchResultSportsFromBackend };

  return defaultRequestService<AdapterProps>(URL.MATCH_RESULT_SPORTS, config.instance.get);
};

export const getMatchResult = (
  config: ServiceConfig,
  reqData: MatchResultRequestData,
) => {
  type AdapterProps = { response: MatchResultDetails };

  const url = `${URL.MATCH_RESULT}?sportId=${reqData.sportId}&startDate=${reqData.startDate}&endDate=${reqData.endDate}`;

  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
